type SampleField =
  | 'legal'
  | 'tax'
  | 'accounting'
  | 'hr'
  | 'cpa'
  | 'cdl'
  | 'caf'
  | 'condominio';

export interface SampleData {
  subject: string;
  body: string;
  attachmentRequired?: boolean;
  fields: SampleField[];
}

export const SAMPLES: SampleData[] = [
  {
    subject: 'Addizionale comunale IRPEF: retroattività',
    body: 'In quali casi l’addizionale comunale all’IRPEF, deliberata da un Comune successivamente all’anno di imposta, assume efficacia retroattiva? Quali sono i riferimenti normativi e come incide in sede di conguaglio?',
    fields: ['tax'],
  },
  {
    subject: 'IVA provvigioni extra UE',
    body: 'Un agente di commercio italiano deve emettere fattura a un’azienda croata per provvigioni relative a vendite extra-UE. Deve applicare l’IVA italiana o si configura un’operazione fuori campo? Come vanno gestite eventuali ritenute?',
    fields: ['tax'],
  },
  {
    subject: 'Registrazione bolla doganale IVA',
    body: 'Ho acquistato merce dalla Cina (resa FOB) e l’ho importata in Italia: come registro correttamente la bolla doganale in contabilità e quali sono gli adempimenti in dichiarazione IVA?',
    fields: ['tax', 'accounting'],
  },
  {
    subject: 'Imputazione costi cessione crediti',
    body: 'Una Srl ha ceduto dei crediti da Superbonus 110% ma ha omesso di rilevare in bilancio i costi bancari relativi a tale cessione. Come devo imputarli ora e quali riflessi fiscali ne derivano?',
    fields: ['tax', 'accounting'],
  },
  {
    subject: 'Detrazioni ristrutturazione 2024',
    body: 'Ho eseguito lavori di ristrutturazione con detrazione al 50% con sconto in fattura nel 2023. Dal 2024 posso ancora usufruire dell’opzione dello sconto per ulteriori interventi? Ci sono limiti, documenti o scadenze particolari da considerare?',
    fields: ['tax'],
  },
  {
    subject: 'Costituzione società semplice immobili',
    body: 'Voglio costituire una società semplice per la gestione di immobili: quali adempimenti contabili e fiscali devo osservare all’inizio? Ci sono limitazioni all’oggetto sociale o particolari obblighi?',
    fields: ['tax'],
  },
  {
    subject: 'Licenziamento dipendente cooperativa',
    body: 'Una cooperativa ha ricevuto segnalazioni di maltrattamenti da parte di una dipendente infermiera verso un ospite. È ammissibile il licenziamento disciplinare o è necessario avviare un procedimento formale? Potresti fornirmi un fac-simile di lettera di contestazione?',
    fields: ['hr', 'legal'],
  },
  {
    subject: 'Compensi amministratore Srl deduzioni',
    body: 'Posso corrispondere i compensi all’amministratore di Srl con busta paga entro il 12 gennaio dell’anno successivo e dedurre il costo nell’esercizio precedente? Quali riferimenti normativi e di prassi si applicano?',
    fields: ['tax'],
  },
  {
    subject: 'Manutenzioni IFRS capitalizzazione',
    body: 'In un bilancio IFRS di una società europea, le manutenzioni straordinarie su un immobile vanno capitalizzate ed ammortizzate? Se sì, in quale voce di Stato patrimoniale e con che criterio di ammortamento?',
    fields: ['accounting'],
  },
  {
    subject: 'Holding e PEX',
    body: 'Vorrei costituire una holding per ridurre il carico fiscale sui dividendi. Quali requisiti per la participation exemption (PEX)? In quali casi si applica?',
    fields: ['tax'],
  },
  {
    subject: 'Riduzione canone locazione cedolare',
    body: 'Ho un contratto di locazione transitorio con cedolare secca al 21%. L’inquilino chiede uno sconto sul canone a metà anno: devo comunicare la riduzione all’Agenzia delle Entrate? Entro quando e con che modalità?',
    fields: ['tax'],
  },
  {
    subject: 'Modello di verbale di assemblea',
    body: 'Scrivi un modello di verbale di assemblea dei soci di Srl per deliberare la distribuzione di dividendi.',
    fields: [],
  },
  {
    subject: 'IVA agricola trasformazione prodotti',
    body: 'Un’azienda agricola individuale in regime di compensazione IVA trasforma il grano in farina e pasta fresca presso terzi. Alla vendita, che aliquota si applica? È compensazione o IVA da versare?',
    fields: ['tax'],
  },
  {
    subject: 'Deducibilità canoni ufficio professionista',
    body: 'Una società vuole verificare la deducibilità dei canoni di locazione di un ufficio per un professionista in contabilità ordinaria. Ci sono limiti o deducibilità integrale?',
    fields: ['tax'],
  },
  {
    subject: 'Società semplice immobiliare',
    body: 'Sto per costituire una società semplice per la gestione di immobili. Quali adempimenti contabili e fiscali devo osservare inizialmente? Ci sono limiti particolari all’oggetto sociale?',
    fields: ['legal', 'tax'],
  },
  {
    subject: 'Conferimento partecipazioni e elusione',
    body: 'Vorrei conferire le mie partecipazioni in una holding ai sensi dell’art. 177 comma 2 del TUIR. In quali casi può essere considerato elusivo e quali precauzioni adottare?',
    fields: ['tax'],
  },
  {
    subject: 'Nota di credito “premi su fatturato”',
    body: 'Mi occorre un parere su una nota di credito emessa per “premi su fatturato” con natura IVA N2.2. Devo indicarla in dichiarazione IVA? In quale quadro o rigo?',
    fields: ['tax', 'accounting'],
  },
  {
    subject: 'Rimborsi chilometrici in regime forfettario',
    body: 'Un professionista in regime forfettario deve gestire i rimborsi chilometrici. Come si inquadra fiscalmente questa voce?',
    fields: ['tax'],
  },
  {
    subject: 'Ente terzo settore e IVA',
    body: 'Se un ente del terzo settore emette fatture senza scopo di lucro, deve comunque applicare l’IVA o può trattarle come fuori campo ai sensi dell’art. 4 DPR 633/72?',
    fields: ['tax'],
  },
  {
    subject: 'Beni Immobili e divorzio',
    body: "Un contribuente è proprietario di un immobile al 50% con sua moglie su cui è presente un mutuo acquisto prima casa. Successivamente il contribuente divorzia e acquista il 50% della casa di proprietà dall'ex moglie, diventando quindi unico proprietario. a tale scopo apre un nuovo mutuo con il quale, in parte paga la rimanente parte del mutuo, e con l'altra parte paga il prezzo pattuito all'ex moglie. è possibile portare in detrazione gli interessi avendo acquisito l'ulteriore 50% con l'agevolazione prima casa? tieni presente che il contribuente è un dipendente delle forze armate per cui non ha la residenza nell'immobile.",
    fields: ['tax'],
  },
  {
    subject: 'Bozza Atto istitutivo Trust',
    body: "Mi prepari una bozza di atto istitutivo di trust di tipo familiare i cui beneficiari sono moglie e figli. La cessazione del trust è alla morte del disponente e la cessazione del trust avverrà o alla morte dello stesso oppure, in subordine, al raggiungimento del venticinquesimo anno di età dell'utlimo dei figli e sempre se il coniuge non è in vita. i due figli hanno 12 e 16 anni; il trustee è la ALFA SRL; i beni conferiti nel trust sono due appartamenti di importo 1.000.000€, liquidità per 750.00€. Trust opaco con clausola di salvaguardia a favore del trustee nel disporre del patrimonio nella cura dello stesso.",
    fields: ['legal'],
  },
  {
    subject: 'Periodo di Assenza ingiustificata',
    body: 'Quale è il periodo di assenza ingiustificata massimo per licenziare un operaio del settore metalmeccanica industria senza precedenti disciplinari.',
    fields: ['hr', 'legal'],
  },
  {
    subject: 'Termine deposito istanza vendita immobile',
    body: "Entro quale termine deve essere depositata l'istanza di vendita dell'immobile pignorato?",
    fields: ['accounting', 'legal'],
  },
  {
    subject: 'Analisi perizia avviamento impresa',
    body: 'Allego in PDF una perizia di stima sull’avviamento di un’impresa che voglio acquistare. Puoi analizzare il documento e verificare la coerenza dei calcoli, gli eventuali riferimenti di legge mancanti e la congruità dei valori finali?',
    attachmentRequired: true,
    fields: ['accounting'],
  },
  {
    subject: 'Revisione contratto finanziamento',
    body: 'Ti carico un PDF contenente il contratto di finanziamento firmato dalla mia società: puoi estrapolare le clausole vincolanti e suggerire eventuali modifiche per cautelarsi in caso di recesso anticipato o risoluzione del contratto?',
    attachmentRequired: true,
    fields: ['legal'],
  },
  {
    subject: 'Parere contratto compravendita aziendale',
    body: 'Allego in PDF la bozza di un contratto di compravendita aziendale. Potresti redigere un parere legale e fiscale evidenziando le clausole critiche, i rischi potenziali e suggerendo eventuali modifiche per tutelare il compratore?',
    attachmentRequired: true,
    fields: ['legal'],
  },
  {
    subject: 'Formazione contratto licenza marchio',
    body: 'Nel PDF trovi una bozza di accordo di licenza d’uso di un marchio tra due società. Ti chiedo di trasformarla in un contratto formale più completo, evidenziando gli articoli necessari (es. oggetto, durata, corrispettivi, recesso, controversie) e allineandolo alla normativa vigente.',
    attachmentRequired: true,
    fields: ['legal'],
  },
  {
    subject: 'Conferimento beni Srl imposte',
    body: 'Allego un PDF contenente la bozza di atto di conferimento di beni immobili in una Srl immobiliare. Mi occorre un parere su eventuali imposte dovute (registro, ipotecarie, catastali) e sulle conseguenze fiscali per la società e per il conferente. Puoi dettagliare anche le scritture contabili basilari?',
    attachmentRequired: true,
    fields: ['tax'],
  },
  {
    subject: 'Relazione tecnica credito R&S',
    body: 'Allego una relazione tecnica per il credito R&S, scrivi un motivo per una memoria illustrativa per eccepire il fatto che tale document dimostra la legittimità del credito fruito.',
    attachmentRequired: true,
    fields: ['tax'],
  },
  {
    subject: 'Analisi Cartella Esattoriale',
    body: 'Allego in PDF la cartella esattoriale ricevuta dall’Agenzia delle Entrate-Riscossione. Puoi esaminarla e verificare se ci sono vizi di forma che possano consentirmi di presentare ricorso?',
    attachmentRequired: true,
    fields: ['tax', 'legal'],
  },
  {
    subject: 'Confronto piani eco-fin',
    body: 'Nel PDF allegato trovi il piano economico-finanziario per una Srl in regime ordinario vs. forfettario. Quali vantaggi/svantaggi fiscali di ciascuna ipotesi?',
    attachmentRequired: true,
    fields: ['accounting', 'tax'],
  },
  {
    subject: 'Fattura e Piano dei conti',
    body: 'Ti allego una fattura e il piano dei conti. Mi dici come devo registrare la fattura in base al piano dei conti?',
    attachmentRequired: true,
    fields: ['accounting'],
  },
  {
    subject: 'Bozza Ricorso Tributario',
    body: "Ti allego un avviso di accertamento ricevuto dall'agenziad delle entrate. Mi prepari una bozza di ricorso tributario?",
    attachmentRequired: true,
    fields: ['tax', 'legal'],
  },
  {
    subject: 'Ricorso per decreto Ingiuntivo',
    body: 'Ti allego una fattura impagata. Redigi un ricorso per decreto ingiuntivo ex art. 633 c.p.c.',
    attachmentRequired: true,
    fields: ['legal'],
  },
  {
    subject: 'Ricorso al giudice di Pace',
    body: 'Redigi un ricorso semplificato di cognizione ex art. 281-undecies c.p.c. davanti al Giudice di Pace per un risarcimento danni da sinistro stradale.',
    attachmentRequired: false,
    fields: ['legal'],
  },
  {
    subject: 'Procure e deleghe',
    body: 'Predisponi una procura alle liti.',
    attachmentRequired: false,
    fields: ['legal'],
  },
  {
    subject: 'Bozze di atti di pignoramento',
    body: 'Scrivi un atto di pignoramento presso terzi ex art. 543 c.p.c.',
    attachmentRequired: false,
    fields: ['legal'],
  },
  {
    subject: 'Bozza di intimazione',
    body: 'Redigi un’intimazione di sfratto per morosità. Utilizza i dati delle parti prendendoli dagli allegati.',
    attachmentRequired: true,
    fields: ['legal'],
  },
  {
    subject: 'Adeguati Assetti',
    body: 'Dammi un giudizio sul bilancio allegato in relazione alla normativa sugli adeguati assetti.',
    attachmentRequired: true,
    fields: ['accounting'],
  },
  {
    subject: 'Bozza di ricorso tributario',
    body: "Analizza l'avviso di accertamento allegato e ipotizza una strategia difensiva.",
    attachmentRequired: true,
    fields: ['tax', 'legal'],
  },
  {
    subject: 'Sviluppa Business Plan in Excel',
    body: 'Analizza il bilancio allegato e sviluppa un Business Plan a 5 anni elencando le ipotesi sottostanti.',
    attachmentRequired: true,
    fields: ['accounting'],
  },
  {
    subject: 'Ricerca bandi e incentivi',
    body: "Allego una visura camerale, quali bandi sono disponibili per l'azienda descritta dalla visura allegata?",
    attachmentRequired: true,
    fields: ['tax'],
  },
  {
    subject: 'Quesito Specifico',
    body: 'Indica le procedure e le precauzioni fiscali necessarie per un titolare di partita IVA italiana che trasferisce la propria residenza in Svizzera e intende continuare a svolgere la medesima attività sul territorio italiano tramite una nuova società italiana, al fine di evitare contestazioni fiscali legate alla modifica della residenza.',
    fields: ['tax'],
  },
  {
    subject: 'Registrazione fattura',
    body: 'Indicami come registrare la fattura in base al piano dei conti allegato.',
    attachmentRequired: true,
    fields: ['accounting'],
  },
];

export const SAMPLES_ARCH_ENG: SampleData[] = [
  {
    subject: 'Titolo edilizio',
    body: "Devo realizzare una diversa distribuzione interna con modifica di tramezzi e impianti. Inquadra l'intervento e dimmi se il titolo corretto è edilizia libera, CILA, SCIA o permesso di costruire, con i punti da verificare a livello comunale.",
    fields: ['legal'],
  },
  {
    subject: 'Efficienza energetica',
    body: 'Per questa riqualificazione con cappotto, serramenti e impianto, indicami gli adempimenti energetici, le verifiche da eseguire, la documentazione tecnica da produrre e i principali riferimenti normativi.',
    fields: ['legal'],
  },
  {
    subject: 'Pratica strutturale e sismica',
    body: "Devo aprire un foro in solaio in edificio esistente. Aiutami a capire se l'intervento è strutturalmente rilevante, quale iter seguire e quali documenti predisporre per deposito o autorizzazione sismica.",
    fields: ['legal'],
  },
  {
    subject: 'Paesaggio e vincoli',
    body: 'Per questo immobile in area vincolata, indicami se serve autorizzazione paesaggistica, se ordinaria o semplificata, quali allegati predisporre e quali profili restano da verificare presso il Comune o la Soprintendenza.',
    fields: ['legal'],
  },
  {
    subject: 'Conto Termico 3.0 e detrazioni fiscali',
    body: "Ti allego la scheda tecnica del generatore e i dati essenziali dell'intervento. Verifica se l'intervento è incentivabile, quali documenti servono e quale modulistica devo predisporre.",
    fields: ['legal'],
  },
  {
    subject: 'PSC / sicurezza cantiere',
    body: 'Ti allego descrizione lavori, imprese coinvolte e cronoprogramma. Predisponi una prima traccia di PSC o una checklist ragionata dei contenuti da completare.',
    fields: ['legal'],
  },
  {
    subject: 'Confronto documenti',
    body: 'Metti a confronto due versioni della relazione tecnica o due computi metrici e sintetizza differenze, incongruenze e punti da verificare prima del deposito o della consegna.',
    fields: ['legal'],
  },
  {
    subject: 'Analisi fascicolo pratica',
    body: 'Ho caricato titolo edilizio, tavole, relazione, visure, schede tecniche e corrispondenza. Ricostruisci il quadro della pratica, segnala mancanze, criticità e passaggi da completare.',
    fields: ['legal'],
  },
  {
    subject: "Varianti in corso d'opera",
    body: 'Durante i lavori sono emerse lavorazioni non previste nel progetto originario. Aiutami a capire se si tratta di variante e quale iter autorizzativo seguire con la stazione appaltante.',
    fields: ['legal'],
  },
  {
    subject: 'Subappalto e verifiche antimafia',
    body: "Devo subappaltare parte dei lavori strutturali a un'impresa specializzata. Indicami i limiti e gli obblighi previsti dal nuovo Codice Appalti, la documentazione da trasmettere alla stazione appaltante, le verifiche antimafia da acquisire e i passaggi da completare prima dell'ingresso in cantiere del subappaltatore.",
    fields: ['legal'],
  },
  {
    subject: 'Qualificazione e documenti di gara',
    body: 'Devo partecipare a una procedura negoziata sotto soglia per manutenzione straordinaria su edificio pubblico. Verificami i requisiti di qualificazione, la documentazione amministrativa da produrre e le dichiarazioni obbligatorie, con i riferimenti aggiornati al nuovo Codice Appalti.',
    fields: ['legal'],
  },
];

export const SAMPLES_APPALTI: SampleData[] = [
  {
    subject: 'Soglie e procedure',
    body: "Per l'importo indicato, determina la procedura corretta da utilizzare tra: affidamento diretto, procedura negoziata, procedura aperta e fornisci una verifica basata sulle soglie normative vigenti.",
    fields: ['legal'],
  },
  {
    subject: 'Capitolato speciale',
    body: 'Crea delle bozze con criteri ambientali minimi (CAM) già inclusi per la merceologia indicata.',
    fields: ['legal'],
  },
  {
    subject: 'Criteri OEPV',
    body: "Crea uno schema dei criteri per l'offerta tecnica in gare con aggiudicazione all'offerta economicamente più vantaggiosa.",
    fields: ['legal'],
  },
  {
    subject: 'Esclusione operatori',
    body: 'Sintetizza le cause di esclusione degli operatori economici ai sensi degli artt. 94-95 del D.Lgs. 36/2023, distinguendo tra cause obbligatorie e cause facoltative.',
    fields: ['legal'],
  },
  {
    subject: "Anomalia dell'offerta",
    body: "Esamina le giustificazioni prodotte verificando la congruità, serietà, sostenibilità e realizzabilità dell'offerta nel suo complesso.",
    fields: ['legal'],
  },
  {
    subject: 'Risposta ANAC',
    body: 'Analizza risposte ANAC inserite, estrai orientamenti principali e applicali a gare in corso conformemente al D.Lgs 36/2023.',
    fields: ['legal'],
  },
  {
    subject: 'Verifica CCNL',
    body: "Individua il CCNL applicabile all'appalto. Verifica equivalenza tutele, tabelle ministeriali costo lavoro e rischi ricorso.",
    fields: ['legal'],
  },
  {
    subject: 'Analisi TAR / CdS',
    body: 'Analizza sentenze TAR/Consiglio di Stato per questo ricorso ricevuto: estrai principi massimati, orientamenti giurisprudenziali prevalenti e impatto su procedure in corso.',
    fields: ['legal'],
  },
];

export const SAMPLES_LEGAL: SampleData[] = [
  {
    subject: 'Ricorso per decreto ingiuntivo',
    body: 'Ti allego fatture, solleciti e PEC. Predisponi una bozza di ricorso per decreto ingiuntivo ex art. 633 c.p.c. con elenco documenti e punti da verificare prima del deposito.',
    fields: ['legal'],
  },
  {
    subject: 'Comparsa e memoria',
    body: 'Analizza questa comparsa di costituzione della controparte, individua eccezioni preliminari, punti deboli e argomenti da contrastare in memoria.',
    fields: ['legal'],
  },
  {
    subject: 'Contratto commerciale',
    body: 'Revisiona questa bozza di contratto di distribuzione e segnala clausole critiche su esclusiva, responsabilità, durata, recesso, foro e penali.',
    fields: ['legal'],
  },
  {
    subject: 'Diffida ad adempiere',
    body: 'Redigi una diffida ad adempiere ex art. 1454 c.c. partendo da questa ricostruzione dei fatti e dagli allegati.',
    fields: ['legal'],
  },
  {
    subject: 'Parere pro veritate',
    body: 'Prepara una traccia di parere sul tema della responsabilità precontrattuale con riferimenti normativi e giurisprudenziali rilevanti.',
    fields: ['legal'],
  },
  {
    subject: 'Analisi allegati',
    body: 'Ho caricato contratto, email e verbali. Ricostruisci la cronologia dei fatti, evidenzia contraddizioni e individua gli elementi utili alla strategia difensiva.',
    fields: ['legal'],
  },
  {
    subject: 'Recupero crediti',
    body: 'Predisponi una bozza di intimazione di pagamento e proponi il percorso più coerente tra diffida, decreto ingiuntivo e azione ordinaria.',
    fields: ['legal'],
  },
  {
    subject: 'Locazione e sfratto',
    body: "Redigi un'intimazione di sfratto per morosità utilizzando i dati delle parti estratti dal contratto e dalla documentazione allegata.",
    fields: ['legal'],
  },
  {
    subject: 'Tributario',
    body: 'Ti allego un avviso di accertamento. Evidenzia possibili vizi, riferimenti normativi e argomenti preliminari per impostare la bozza di ricorso.',
    fields: ['legal'],
  },
  {
    subject: 'Lavoro',
    body: 'Analizza la documentazione disciplinare e preparami una bozza di contestazione o di memoria difensiva, indicando i passaggi da verificare alla luce del CCNL applicabile.',
    fields: ['legal'],
  },
  {
    subject: 'Societario',
    body: 'Trasforma questi appunti e allegati in una bozza di verbale assembleare o di parere su delibere, responsabilità degli amministratori o distribuzione di utili.',
    fields: ['legal'],
  },
  {
    subject: 'Confronto documenti',
    body: 'Metti a confronto due versioni dello stesso contratto e sintetizza in modo chiaro tutte le modifiche rilevanti sul piano legale e negoziale.',
    fields: ['legal'],
  },
];

export const SAMPLES_CPA: SampleData[] = [
  {
    subject: 'Addizionale comunale IRPEF: retroattività',
    body: 'In quali casi l’addizionale comunale all’IRPEF, deliberata da un Comune successivamente all’anno di imposta, assume efficacia retroattiva? Quali sono i riferimenti normativi e come incide in sede di conguaglio?',
    fields: ['tax'],
  },
  {
    subject: 'IVA provvigioni extra UE',
    body: 'Un agente di commercio italiano deve emettere fattura a un’azienda croata per provvigioni relative a vendite extra-UE. Deve applicare l’IVA italiana o si configura un’operazione fuori campo? Come vanno gestite eventuali ritenute?',
    fields: ['tax'],
  },
  {
    subject: 'Registrazione bolla doganale IVA',
    body: 'Ho acquistato merce dalla Cina (resa FOB) e l’ho importata in Italia: come registro correttamente la bolla doganale in contabilità e quali sono gli adempimenti in dichiarazione IVA?',
    fields: ['tax', 'accounting'],
  },
  {
    subject: 'Imputazione costi cessione crediti',
    body: 'Una Srl ha ceduto dei crediti da Superbonus 110% ma ha omesso di rilevare in bilancio i costi bancari relativi a tale cessione. Come devo imputarli ora e quali riflessi fiscali ne derivano?',
    fields: ['tax', 'accounting'],
  },
  {
    subject: 'Detrazioni ristrutturazione 2024',
    body: 'Ho eseguito lavori di ristrutturazione con detrazione al 50% con sconto in fattura nel 2023. Dal 2024 posso ancora usufruire dell’opzione dello sconto per ulteriori interventi? Ci sono limiti, documenti o scadenze particolari da considerare?',
    fields: ['tax'],
  },
  {
    subject: 'Costituzione società semplice immobili',
    body: 'Voglio costituire una società semplice per la gestione di immobili: quali adempimenti contabili e fiscali devo osservare all’inizio? Ci sono limitazioni all’oggetto sociale o particolari obblighi?',
    fields: ['tax'],
  },
  {
    subject: 'Compensi amministratore Srl deduzioni',
    body: 'Posso corrispondere i compensi all’amministratore di Srl con busta paga entro il 12 gennaio dell’anno successivo e dedurre il costo nell’esercizio precedente? Quali riferimenti normativi e di prassi si applicano?',
    fields: ['tax'],
  },
  {
    subject: 'Manutenzioni IFRS capitalizzazione',
    body: 'In un bilancio IFRS di una società europea, le manutenzioni straordinarie su un immobile vanno capitalizzate ed ammortizzate? Se sì, in quale voce di Stato patrimoniale e con che criterio di ammortamento?',
    fields: ['accounting'],
  },
  {
    subject: 'Holding e PEX',
    body: 'Vorrei costituire una holding per ridurre il carico fiscale sui dividendi. Quali requisiti per la participation exemption (PEX)? In quali casi si applica?',
    fields: ['tax'],
  },
  {
    subject: 'Riduzione canone locazione cedolare',
    body: 'Ho un contratto di locazione transitorio con cedolare secca al 21%. L’inquilino chiede uno sconto sul canone a metà anno: devo comunicare la riduzione all’Agenzia delle Entrate? Entro quando e con che modalità?',
    fields: ['tax'],
  },
  {
    subject: 'Modello di verbale di assemblea',
    body: 'Scrivi un modello di verbale di assemblea dei soci di Srl per deliberare la distribuzione di dividendi.',
    fields: [],
  },
  {
    subject: 'IVA agricola trasformazione prodotti',
    body: 'Un’azienda agricola individuale in regime di compensazione IVA trasforma il grano in farina e pasta fresca presso terzi. Alla vendita, che aliquota si applica? È compensazione o IVA da versare?',
    fields: ['tax'],
  },
  {
    subject: 'Deducibilità canoni ufficio professionista',
    body: 'Una società vuole verificare la deducibilità dei canoni di locazione di un ufficio per un professionista in contabilità ordinaria. Ci sono limiti o deducibilità integrale?',
    fields: ['tax'],
  },
  {
    subject: 'Società semplice immobiliare',
    body: 'Sto per costituire una società semplice per la gestione di immobili. Quali adempimenti contabili e fiscali devo osservare inizialmente? Ci sono limiti particolari all’oggetto sociale?',
    fields: ['legal', 'tax'],
  },
  {
    subject: 'Conferimento partecipazioni e elusione',
    body: 'Vorrei conferire le mie partecipazioni in una holding ai sensi dell’art. 177 comma 2 del TUIR. In quali casi può essere considerato elusivo e quali precauzioni adottare?',
    fields: ['tax'],
  },
  {
    subject: 'Nota di credito “premi su fatturato”',
    body: 'Mi occorre un parere su una nota di credito emessa per “premi su fatturato” con natura IVA N2.2. Devo indicarla in dichiarazione IVA? In quale quadro o rigo?',
    fields: ['tax', 'accounting'],
  },
  {
    subject: 'Rimborsi chilometrici in regime forfettario',
    body: 'Un professionista in regime forfettario deve gestire i rimborsi chilometrici. Come si inquadra fiscalmente questa voce?',
    fields: ['tax'],
  },
  {
    subject: 'Ente terzo settore e IVA',
    body: 'Se un ente del terzo settore emette fatture senza scopo di lucro, deve comunque applicare l’IVA o può trattarle come fuori campo ai sensi dell’art. 4 DPR 633/72?',
    fields: ['tax'],
  },
  {
    subject: 'Beni Immobili e divorzio',
    body: "Un contribuente è proprietario di un immobile al 50% con sua moglie su cui è presente un mutuo acquisto prima casa. Successivamente il contribuente divorzia e acquista il 50% della casa di proprietà dall'ex moglie, diventando quindi unico proprietario. a tale scopo apre un nuovo mutuo con il quale, in parte paga la rimanente parte del mutuo, e con l'altra parte paga il prezzo pattuito all'ex moglie. è possibile portare in detrazione gli interessi avendo acquisito l'ulteriore 50% con l'agevolazione prima casa? tieni presente che il contribuente è un dipendente delle forze armate per cui non ha la residenza nell'immobile.",
    fields: ['tax'],
  },
  {
    subject: 'Bozza Atto istitutivo Trust',
    body: "Mi prepari una bozza di atto istitutivo di trust di tipo familiare i cui beneficiari sono moglie e figli. La cessazione del trust è alla morte del disponente e la cessazione del trust avverrà o alla morte dello stesso oppure, in subordine, al raggiungimento del venticinquesimo anno di età dell'utlimo dei figli e sempre se il coniuge non è in vita. i due figli hanno 12 e 16 anni; il trustee è la ALFA SRL; i beni conferiti nel trust sono due appartamenti di importo 1.000.000€, liquidità per 750.00€. Trust opaco con clausola di salvaguardia a favore del trustee nel disporre del patrimonio nella cura dello stesso.",
    fields: ['legal'],
  },
  {
    subject: 'Periodo di Assenza ingiustificata',
    body: 'Quale è il periodo di assenza ingiustificata massimo per licenziare un operaio del settore metalmeccanica industria senza precedenti disciplinari.',
    fields: ['hr', 'legal'],
  },
  {
    subject: 'Termine deposito istanza vendita immobile',
    body: "Entro quale termine deve essere depositata l'istanza di vendita dell'immobile pignorato?",
    fields: ['accounting', 'legal'],
  },
  {
    subject: 'Analisi perizia avviamento impresa',
    body: 'Allego in PDF una perizia di stima sull’avviamento di un’impresa che voglio acquistare. Puoi analizzare il documento e verificare la coerenza dei calcoli, gli eventuali riferimenti di legge mancanti e la congruità dei valori finali?',
    attachmentRequired: true,
    fields: ['accounting'],
  },
  {
    subject: 'Revisione contratto finanziamento',
    body: 'Ti carico un PDF contenente il contratto di finanziamento firmato dalla mia società: puoi estrapolare le clausole vincolanti e suggerire eventuali modifiche per cautelarsi in caso di recesso anticipato o risoluzione del contratto?',
    attachmentRequired: true,
    fields: ['legal'],
  },
  {
    subject: 'Parere contratto compravendita aziendale',
    body: 'Allego in PDF la bozza di un contratto di compravendita aziendale. Potresti redigere un parere legale e fiscale evidenziando le clausole critiche, i rischi potenziali e suggerendo eventuali modifiche per tutelare il compratore?',
    attachmentRequired: true,
    fields: ['legal'],
  },
  {
    subject: 'Formazione contratto licenza marchio',
    body: 'Nel PDF trovi una bozza di accordo di licenza d’uso di un marchio tra due società. Ti chiedo di trasformarla in un contratto formale più completo, evidenziando gli articoli necessari (es. oggetto, durata, corrispettivi, recesso, controversie) e allineandolo alla normativa vigente.',
    attachmentRequired: true,
    fields: ['legal'],
  },
  {
    subject: 'Conferimento beni Srl imposte',
    body: 'Allego un PDF contenente la bozza di atto di conferimento di beni immobili in una Srl immobiliare. Mi occorre un parere su eventuali imposte dovute (registro, ipotecarie, catastali) e sulle conseguenze fiscali per la società e per il conferente. Puoi dettagliare anche le scritture contabili basilari?',
    attachmentRequired: true,
    fields: ['tax'],
  },
  {
    subject: 'Relazione tecnica credito R&S',
    body: 'Allego una relazione tecnica per il credito R&S, scrivi un motivo per una memoria illustrativa per eccepire il fatto che tale document dimostra la legittimità del credito fruito.',
    attachmentRequired: true,
    fields: ['tax'],
  },
  {
    subject: 'Analisi Cartella Esattoriale',
    body: 'Allego in PDF la cartella esattoriale ricevuta dall’Agenzia delle Entrate-Riscossione. Puoi esaminarla e verificare se ci sono vizi di forma che possano consentirmi di presentare ricorso?',
    attachmentRequired: true,
    fields: ['tax', 'legal'],
  },
  {
    subject: 'Confronto piani eco-fin',
    body: 'Nel PDF allegato trovi il piano economico-finanziario per una Srl in regime ordinario vs. forfettario. Quali vantaggi/svantaggi fiscali di ciascuna ipotesi?',
    attachmentRequired: true,
    fields: ['accounting', 'tax'],
  },
  {
    subject: 'Fattura e Piano dei conti',
    body: 'Ti allego una fattura e il piano dei conti. Mi dici come devo registrare la fattura in base al piano dei conti?',
    attachmentRequired: true,
    fields: ['accounting'],
  },
  {
    subject: 'Bozza Ricorso Tributario',
    body: "Ti allego un avviso di accertamento ricevuto dall'agenziad delle entrate. Mi prepari una bozza di ricorso tributario?",
    attachmentRequired: true,
    fields: ['tax', 'legal'],
  },
  {
    subject: 'Ricorso per decreto Ingiuntivo',
    body: 'Ti allego una fattura impagata. Redigi un ricorso per decreto ingiuntivo ex art. 633 c.p.c.',
    attachmentRequired: true,
    fields: ['legal'],
  },
  {
    subject: 'Ricorso al giudice di Pace',
    body: 'Redigi un ricorso semplificato di cognizione ex art. 281-undecies c.p.c. davanti al Giudice di Pace per un risarcimento danni da sinistro stradale.',
    attachmentRequired: false,
    fields: ['legal'],
  },
  {
    subject: 'Procure e deleghe',
    body: 'Predisponi una procura alle liti.',
    attachmentRequired: false,
    fields: ['legal'],
  },
  {
    subject: 'Bozze di atti di pignoramento',
    body: 'Scrivi un atto di pignoramento presso terzi ex art. 543 c.p.c.',
    attachmentRequired: false,
    fields: ['legal'],
  },
  {
    subject: 'Bozza di intimazione',
    body: 'Redigi un’intimazione di sfratto per morosità. Utilizza i dati delle parti prendendoli dagli allegati.',
    attachmentRequired: true,
    fields: ['legal'],
  },
  {
    subject: 'Adeguati Assetti',
    body: 'Dammi un giudizio sul bilancio allegato in relazione alla normativa sugli adeguati assetti.',
    attachmentRequired: true,
    fields: ['accounting'],
  },
  {
    subject: 'Bozza di ricorso tributario',
    body: "Analizza l'avviso di accertamento allegato e ipotizza una strategia difensiva.",
    attachmentRequired: true,
    fields: ['tax', 'legal'],
  },
  {
    subject: 'Sviluppa Business Plan in Excel',
    body: 'Analizza il bilancio allegato e sviluppa un Business Plan a 5 anni elencando le ipotesi sottostanti.',
    attachmentRequired: true,
    fields: ['accounting'],
  },
  {
    subject: 'Ricerca bandi e incentivi',
    body: "Allego una visura camerale, quali bandi sono disponibili per l'azienda descritta dalla visura allegata?",
    attachmentRequired: true,
    fields: ['tax'],
  },
  {
    subject: 'Quesito Specifico',
    body: 'Indica le procedure e le precauzioni fiscali necessarie per un titolare di partita IVA italiana che trasferisce la propria residenza in Svizzera e intende continuare a svolgere la medesima attività sul territorio italiano tramite una nuova società italiana, al fine di evitare contestazioni fiscali legate alla modifica della residenza.',
    fields: ['tax'],
  },
  {
    subject: 'Registrazione fattura',
    body: 'Indicami come registrare la fattura in base al piano dei conti allegato.',
    attachmentRequired: true,
    fields: ['accounting'],
  },
  {
    subject: 'Adeguati Assetti',
    body: 'Dammi un giudizio sul bilancio allegato in relazione alla normativa sugli adeguati assetti.',
    fields: ['cpa'],
  },
  {
    subject: 'Bozza di ricorso tributario',
    body: 'Analizza l’avviso di accertamento allegato e ipotizza una strategia difensiva.',
    fields: ['cpa'],
  },
  {
    subject: 'Sviluppa Business Plan in Excel',
    body: 'Analizza il bilancio allegato e sviluppa un Business Plan a 5 anni elencando le ipotesi sottostanti.',
    fields: ['cpa'],
  },
  {
    subject: 'Ricerca bandi e incentivi',
    body: 'Allego una visura camerale, quali bandi sono disponibili per l’azienda descritta dalla visura allegata?',
    fields: ['cpa'],
  },
  {
    subject: 'Quesito Specifico',
    body: 'Indica le procedure e le precauzioni fiscali necessarie per un titolare di partita IVA italiana che trasferisce la propria residenza in Svizzera e intende continuare a svolgere la medesima attività sul territorio italiano tramite una nuova società italiana, al fine di evitare contestazioni fiscali legate alla modifica della residenza.',
    fields: ['cpa'],
  },
  {
    subject: 'Registrazione fattura',
    body: 'Indicami come registrare la fattura in base al piano dei conti allegato.',
    fields: ['cpa'],
  },
];

export const SAMPLES_CDL: SampleData[] = [
  {
    subject:
      'Inquadramento e applicazione del CCNL e dei contratti provinciali',
    body: 'Devo inquadrare una nuova assunzione: ti indico mansioni, settore e sede di lavoro. Individua il CCNL nazionale applicabile e l’eventuale accordo territoriale, proponi il livello di inquadramento coerente ed elenca i punti da verificare prima di formalizzare.',
    fields: ['cdl'],
  },
  {
    subject: 'Contestazione disciplinare',
    body: 'Ti allego la ricostruzione dei fatti e la documentazione. Predisponi una bozza di lettera di contestazione disciplinare ai sensi dell’art. 7 L. 300/1970, con la sequenza procedurale e i termini da rispettare alla luce del CCNL applicabile.',
    fields: ['cdl'],
  },
  {
    subject: 'Ammortizzatori sociali',
    body: 'L’azienda cliente deve sospendere l’attività per un calo di commesse. Inquadra lo strumento più coerente tra CIG, fondi di solidarietà e altre tutele, indicando requisiti, documentazione e adempimenti procedurali da verificare.',
    fields: ['cdl'],
  },
  {
    subject: 'Ispezioni e verbali',
    body: 'Ti allego il verbale di accertamento dell’INL. Evidenzia i rilievi contestati, i riferimenti normativi richiamati e gli elementi utili per impostare le osservazioni o una memoria difensiva.',
    fields: ['cdl'],
  },
  {
    subject: 'Controllo di cedolini, LUL e Uniemens',
    body: 'Ti allego cedolino, LUL e dati Uniemens. Verifica la coerenza tra voci retributive, istituti contrattuali e CCNL applicato, segnalando scostamenti e punti da controllare prima della chiusura del mese.',
    fields: ['cdl'],
  },
  {
    subject: 'Cessazione del rapporto e spettanze finali',
    body: 'Sto chiudendo un rapporto di lavoro: ti indico data di assunzione, livello e CCNL. Elencami le spettanze di fine rapporto da liquidare (TFR, ferie e ROL residui, mensilità aggiuntive, eventuale preavviso) e i punti da verificare prima del conguaglio.',
    fields: ['cdl'],
  },
  {
    subject: 'Trasformazione del contratto',
    body: 'Devo trasformare un contratto da tempo determinato a indeterminato (o da part-time a full-time): ti descrivo la situazione. Indicami gli adempimenti, le comunicazioni obbligatorie e gli elementi da aggiornare nel contratto e in busta paga.',
    fields: ['cdl'],
  },
  {
    subject: 'Welfare aziendale e premi di produttività',
    body: 'L’azienda cliente vuole introdurre un piano di welfare o un premio di produttività. Spiegami le condizioni per il trattamento agevolato, la documentazione necessaria e i punti da verificare prima di impostarlo.',
    fields: ['cdl'],
  },
  {
    subject: 'Licenziamento dipendente',
    body: 'Una cooperativa ha ricevuto segnalazioni di maltrattamenti da parte di una dipendente infermiera verso un ospite. È ammissibile il licenziamento disciplinare o è necessario avviare un procedimento formale?',
    fields: ['cdl'],
  },
  {
    subject: 'Redazione Contratto di Lavoro',
    body: 'Redigi un contratto di lavoro per la risorsa di cui allego CI, con un Reddito Annuo Lordo (RAL) di 35.000 euro, applicando il Contratto Collettivo Nazionale di Lavoro (CCNL) del settore commercio e inquadrata al primo livello.',
    attachmentRequired: true,
    fields: ['cdl'],
  },
];

export const SAMPLES_CAF: SampleData[] = [
  {
    subject: 'Verifica Spese Detraibili e Deducibili (Modello 730)',
    body: 'Analizza fatture, bonifici di ristrutturazione e spese mediche complesse: verifica i criteri di tracciabilità, i limiti massimi detraibili e i documenti da conservare obbligatoriamente nel fascicolo.',
    fields: ['caf'],
  },
  {
    subject: 'Calcolo ISEE e Gestione DSU',
    body: 'Identifica la corretta composizione del nucleo familiare in casi complessi (genitori non conviventi, figli maggiorenni a carico, disabilità), indicando i quadri DSU da compilare e i documenti necessari.',
    fields: ['caf'],
  },
  {
    subject: 'Contratti Colf e Badanti',
    body: 'Individua il livello di inquadramento corretto in base al CCNL Lavoro Domestico, calcola la paga minima, genera la lettera di assunzione e il piano dei contributi INPS trimestrali.',
    fields: ['caf'],
  },
  {
    subject: 'Pratiche di Successione',
    body: 'Calcola le quote spettanti a ciascun erede, determina le imposte ipotecarie e catastali e imposta la documentazione per la presentazione.',
    fields: ['caf'],
  },
  {
    subject: 'Controllo CU e Redditi Esteri',
    body: "Esamina situazioni con più Certificazioni Uniche o redditi prodotti all'estero, verifica l'obbligo di presentazione del dichiarativo e indica i righi esatti del 730 per l'inserimento dati.",
    fields: ['caf'],
  },
  {
    subject: 'Bonus Sociali e Assegno Unico',
    body: "Verifica di requisiti di accesso aggiornati, le soglie ISEE e le compatibilità normative per l'invio telematico delle domande INPS o dei bonus luce e gas.",
    fields: ['caf'],
  },
  {
    subject: 'Calcolo IMU e F24',
    body: 'Incrocia rendite catastali, aliquote comunali aggiornate e quote di possesso (anche per immobili ereditati) per calcolare acconto e saldo IMU e predisporre il modello F24.',
    fields: ['caf'],
  },
  {
    subject: "Controlli dell'Agenzia delle Entrate (36-ter)",
    body: 'Analizza le comunicazioni di irregolarità o le richieste di documenti ricevute dai contribuenti, evidenzia le difformità segnalate dal fisco e bozza la nota di risposta per lo sgravio.',
    fields: ['caf'],
  },
];

export const SAMPLES_CONDOMINIO: SampleData[] = [
  {
    subject: 'Convocazioni e Ordine del Giorno',
    body: 'Genera bozze di convocazione per assemblee ordinarie e straordinarie, indicando i punti da discutere e i quorum costitutivi e deliberativi richiesti dal Codice Civile.',
    fields: ['condominio'],
  },
  {
    subject: 'Verbali e Delibere Assembleari',
    body: 'Trasforma gli appunti presi in assemblea in un verbale definitivo, formale e strutturato, verificando il rispetto delle maggioranze di legge per evitare impugnazioni.',
    fields: ['condominio'],
  },
  {
    subject: 'Confronto Preventivi e Appalti',
    body: 'Analizza e confronta i preventivi delle ditte (es. rifacimento facciate), estraendo voci di costo, anomalie, esclusioni o penali per presentarli chiaramente ai condomini.',
    fields: ['condominio'],
  },
  {
    subject: 'Recupero Crediti e Morosità',
    body: 'Predispone lettere di sollecito bonario e formali messe in mora per i condomini in ritardo con i pagamenti, definendo i passaggi legali corretti (art. 63 Disp. Att. c.c.).',
    fields: ['condominio'],
  },
  {
    subject: 'Contratti con i Fornitori',
    body: 'Analizza contratti di pulizia, manutenzione ascensori o polizze assicurative, segnalando clausole vessatorie, scadenze nascoste e termini di disdetta.',
    fields: ['condominio'],
  },
  {
    subject: 'Ripartizione Spese e Tabelle',
    body: 'Individua i criteri legali e giurisprudenziali per ripartire correttamente le spese complesse (es. riscaldamento, scale, ascensori) in base al Codice Civile e al regolamento.',
    fields: ['condominio'],
  },
  {
    subject: 'Adempimenti Fiscali e Detrazioni',
    body: "Verifica i requisiti per l'applicazione delle ritenute d'acconto, la corretta gestione del Modello 770 e gli adempimenti necessari per non perdere i bonus edilizi.",
    fields: ['condominio'],
  },
  {
    subject: 'Controversie e Regolamento',
    body: 'Fornisce risposte supportate dalla Cassazione per gestire violazioni del regolamento condominiale, uso illecito delle parti comuni o immissioni di rumore.',
    fields: ['condominio'],
  },
  {
    subject: 'Comunicazioni Fiscali Annuali',
    body: "Supporta l'amministratore nella gestione degli obblighi fiscali periodici, come Quadro AC, Certificazioni Uniche e comunicazioni all'Anagrafe Tributaria, chiarendo criteri, soglie, scadenze e dati da indicare.",
    fields: ['condominio'],
  },
  {
    subject: 'Certificazioni per Bonus Edilizi',
    body: 'Verifica come predisporre correttamente le certificazioni relative a ristrutturazioni, risparmio energetico e detrazioni fiscali, anche in presenza di pertinenze, box, cantine o tabelle millesimali incomplete.',
    fields: ['condominio'],
  },
  {
    subject: 'Scadenze, Invii Tardivi e Sanzioni',
    body: 'Analizza le conseguenze di adempimenti fiscali inviati oltre i termini, indicando eventuali sanzioni, margini di regolarizzazione e comportamenti corretti da adottare.',
    fields: ['condominio'],
  },
  {
    subject: 'Note di Credito e Rettifiche Contabili',
    body: 'Aiuta a gestire casi contabili complessi, come note di credito riferite ad anni precedenti, fatture con ritenute già versate e dichiarazioni fiscali già trasmesse.',
    fields: ['condominio'],
  },
  {
    subject: 'Bilanci Condominiali e Rendiconti',
    body: "Trasforma bilanci, prospetti e documenti contabili in verbali di approvazione chiari e formali, evidenziando l'esito della votazione e la corretta verbalizzazione assembleare.",
    fields: ['condominio'],
  },
  {
    subject: 'Fondi Condominiali e Vendita Immobile',
    body: 'Fornisce indicazioni operative sulla gestione dei fondi accantonati, sulla loro eventuale restituzione e sui rapporti tra condominio, venditore e acquirente in caso di compravendita.',
    fields: ['condominio'],
  },
];
